import React from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import MatchDaysPage from "./MatchDaysPage";
import "./i18/i18n";

const matchDaysLayout = (props) => {
    return (
        <Provider store={store}>
            <MatchDaysPage
                data={props.data}
                locale={props.router?.attributes?.locale}
            />
        </Provider>
    );
};

export default matchDaysLayout;
